import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { CheckableRowBody } from "../../../../components/RowValue/CheckableRowBody";
import { decimalSeparator, thousandSeparator } from "../../../../i18n";

export default function DowntimesEquipmentAndWorkforce({ value, set, isChecked, onChecked }) {
  const { t } = useTranslation("translation");

  function renderInput() {
    return (
      <NumberFormat
        className={"change-input"}
        decimalScale={0}
        value={value}
        thousandSeparator={thousandSeparator()}
        decimalSeparator={decimalSeparator()}
        displayType="input"
        type="text"
        onValueChange={(value) => set(value.floatValue)}
        allowNegative={false}
      />
    );
  }

  return (
    <CheckableRowBody
      isChecked={isChecked}
      onChecked={onChecked}
      titleValue={<p>{t("lvText.positionRequirements.downtimesEquipmentAndWorkforce")}</p>}
      inputValue={renderInput()}
      unitValue={"Std"}
    />
  );
}
